export default function saveState(
  key: string,
  state: unknown,
  storage: Storage = window.localStorage
) {
  if (state) storage.setItem(key, JSON.stringify(state))
  else storage.removeItem(key)
}
